import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: string | Date): string {
  return new Date(date).toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

export function getScoreLabel(score: number): string {
  const labels: Record<number, string> = {
    1: 'Très insuffisant',
    2: 'Insuffisant',
    3: 'Satisfaisant',
    4: 'Très bonne maîtrise'
  }
  return labels[score] || 'Non évalué'
}

export function getScoreColor(score: number): string {
  const colors: Record<number, string> = {
    1: 'bg-red-500',
    2: 'bg-orange-500',
    3: 'bg-yellow-500',
    4: 'bg-green-500'
  }
  return colors[score] || 'bg-gray-300'
}
